var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F14937",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F14937",
  d: "M4.5 19v-4h1.758q.479 0 .826.176.35.174.538.486.19.31.19.723 0 .414-.194.724-.192.31-.547.479a1.94 1.94 0 0 1-.844.17H5.142v-.762h.894a.9.9 0 0 0 .389-.076.54.54 0 0 0 .239-.213.63.63 0 0 0 .08-.322.6.6 0 0 0-.08-.32.53.53 0 0 0-.24-.212.9.9 0 0 0-.388-.074H5.53V19zM9.892 19H8.318v-4H9.89q.65 0 1.12.24.472.239.728.688.255.447.255 1.07 0 .625-.255 1.074-.254.45-.726.69-.472.238-1.12.238m-.545-.824h.505q.358 0 .605-.113a.77.77 0 0 0 .377-.373q.128-.26.128-.692t-.128-.687a.77.77 0 0 0-.38-.371 1.5 1.5 0 0 0-.616-.116h-.49zM12.594 19v-4H15.5v.785h-1.877v.82h1.692v.788h-1.692V19z"
})));
export default SvgPdf;